<template>
  <fin-data-loader :resolver="loadData" ref="datafetcher" overlay fullpage>
    <template #content>
      <Portal v-if="instrument" to="breadcrumb_etfDetail">
        {{ instrument.name }}
      </Portal>

      <div class="fin-etf-page">
        <template v-if="$route.name !== 'addEtfToPortfolio'">

          <fin-instrument-detail-header
            :no-escape-link="noEscapeLink"
            :sub-line-values="subLineValues"
            current-value
            :key-figures="keyFigures"
            :daily-data="dailyData"
            :tabs="tabs"
            :instrument="instrument">
            <template #tab0>
              <!--TODO maybe better handling, with named observables-->
              <fin-etf-page-overview
                :realtime-subscription="subscriptionManager.observables[0]"
                :instrument="instrument"
              />
            </template>
            <template #tab1>
              <fin-instrument-performance-page :instrument="instrument"/>
            </template>
            <template #tab2>
              <fin-etf-page-portfolio :instrument="instrument"/>
            </template>
            <template #tab3>
              <fin-etf-page-data :instrument="instrument"/>
            </template>
            <template #tab4>
              <fin-etf-page-dividend :instrument="instrument"/>
            </template>
            <template #tab5>
              <fin-etf-page-risk :instrument="instrument"/>
            </template>
          </fin-instrument-detail-header>

        </template>
        <router-view v-else :instruments="[instrument]"/>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import { finEtfAPI } from "@/js/finAPI"
import FinEtfPageData from "@/components/pages/finEtfPage/EtfPageData"
import FinEtfPageDividend from "@/components/pages/finEtfPage/EtfPageDividend"
import FinEtfPageOverview from "@/components/pages/finEtfPage/EtfPageOverview"
import FinEtfPagePortfolio from "@/components/pages/finEtfPage/EtfPagePortfolio"
import FinEtfPageRisk from "@/components/pages/finEtfPage/EtfPageRisk"
import FinInstrumentDetailHeader from "@/components/pages/instrumentPages/instrumentDetailPage"
import { TablePresets } from "@/components/common/DataTable/DefaultHeaders"
import { companyDetailsSubscription } from "@/js/finSubscriptions"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import FinDataLoader from "@/components/common/DataLoader"
import FinInstrumentPerformancePage from "@/components/pages/instrumentPages/instrumentPerformancePage"

export default {
  name: 'fin-etf-page',
  mixins: [SubscriptionHandler],
  components: {
    FinInstrumentPerformancePage,
    FinDataLoader,
    FinInstrumentDetailHeader,
    FinEtfPageData,
    FinEtfPageDividend,
    FinEtfPageOverview,
    FinEtfPagePortfolio,
    FinEtfPageRisk,
  },
  props: {
    id: {
      type: String
    },
    displayColor: {
      type: String,
      default: '$finColor.primaryDark'
    },
    /** if the etf page is opened from the onboarding, then no link should allow
     * the user to quit the onboarding pages */
    noEscapeLink: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      subLineValues: TablePresets.createEtfDetailPageSubtitle(),
      keyFigures: TablePresets.createEtfDetailPageKeyFigures(),
      dailyData: TablePresets.createDetailPageDailyDevelopment(),
      instrument: undefined
    }
  },
  methods: {
    async loadData(){
      this.unsubscribeChanges()
      await this.loadEtf()
    },
    async loadEtf() {
      this.instrument = await finEtfAPI.getEtf(this.id)
      this.subscribeToChanges(
        this.instrument,
        companyDetailsSubscription,
        (etf) => {
          return {id: etf.isin}
        },
        this.handleSubscription
      )
    },
    handleSubscription(data) {
      let {
        id,
        price,
        priceChange,
        priceChangePercentage,
        timestamp,
        high,
        low,
        exchangeName
      } = data.data.onCreateRealTimePrice

      if (id === this.instrument.isin) {
        this.instrument.latestPrice = {
          price: price,
          timestamp: timestamp,
          exchangeName: `Börse ${ exchangeName }: `
        }
        this.instrument.closeChangeAbsolute1D = priceChange
        this.instrument.closeChange1D = priceChangePercentage
        this.instrument.high = high
        this.instrument.low = low
      }
    }
  },
  computed: {
    exchangeName() {
      return this.instrument.latestPrice?.exchangeName
    },
    tabs(){
      return [
        {name: 'Übersicht'},
        {name: 'Performance'},
        {name: 'Portfolio'},
        {name: 'Stammdaten'},
        {name: 'Ausschüttung', hidden: this.instrument.dividendTreatment !== 'Distributes'},
        {name: 'Risiko'}
      ]
    }
  },
  watch: {
    id() {
      // url param id changes e.g. because of search -> reload page data
      this.$refs.datafetcher._fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.expense-ratio {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.1;
  color: var(--night-blue);
}

.expense-ratio-desc {
  font-size: 12px;
  line-height: 1.25;
  color: var(--grey-7);
}
</style>
